module.exports = __webpack_public_path__ + "img/setting_6.5713253c.svg";